module.exports = __webpack_public_path__ + "img/banniere_2.20f1493d.jpg";